import { render, staticRenderFns } from "./AvailableDiscountsModal.vue?vue&type=template&id=58f75078&scoped=true"
import script from "./AvailableDiscountsModal.vue?vue&type=script&lang=ts"
export * from "./AvailableDiscountsModal.vue?vue&type=script&lang=ts"
import style0 from "./AvailableDiscountsModal.vue?vue&type=style&index=0&id=58f75078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f75078",
  null
  
)

export default component.exports